export const TAB_IDS = {
  MEALS: "meals",
  APPROVERS: "approvers",
  MANAGER_PASSWORD: "manager"
};
